<script lang="ts">
  import { createEventDispatcher } from "svelte";
  import { Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, TabContent, TabPane } from "sveltestrap";
import { error, success } from "../../../../public/my-theme";
import type { Fn } from "../../../global";
import type { Pedestrian } from "../../../Model/Pedestrian";
import type { Third } from "../../../Model/Third";
import { pedestrianService } from "../../../services";
import PedestrianInfoForm from "./PedestrianInfoForm.svelte";


  export let pedestrianThird: Third;
  export let diligenceId: string;
  export let open = false;
  export let toggle: Fn = undefined;

  $: load(diligenceId, pedestrianThird)

  let size = "lg";
  let pedestrian: Pedestrian;

  const dispatch = createEventDispatcher();

  async function load(diligenceId, pedestrianThird){
    if (diligenceId && pedestrianThird) {
      let pedestrians: Pedestrian[] = await pedestrianService.findByDiligenceNumber(diligenceId)
      pedestrian = pedestrians.find(c => c.pedestrianThirId == pedestrianThird.id)
    }
  }

  async function savePedestrianTraffic() {
    try {
      save()
      toggle()
      success("Datos guardados con exito");
    } catch (err) {
      error("Comprueba los campos");
    }
  }

  async function changeThirdList(third){
    pedestrian.pedestrianThirId = third.id;
    save()
  }

  async function save(){
    await Promise.all([ 
      pedestrianService.savePedestrian(pedestrian),
    ])

    dispatch('savePedestrian');
  }

</script>

<Modal isOpen={open} {toggle} {size}>
  <ModalHeader {toggle}>Editar</ModalHeader>
  <ModalBody>

    <TabContent>
      {#if pedestrian}
      <TabPane tabId="Datos" tab="Datos" active>
          <PedestrianInfoForm pedestrian={pedestrian} on:changeThirdLIst={(event) => changeThirdList(event.detail)}/>
      </TabPane>
        <TabPane tabId="dataInfo2" tab="Inf.Médico">
          <div class="row mt-2">
            <div class="col-12 mb-2">
              <Label>Historial Médico</Label>
              <Input
                type="textarea"
                rows={6}
                bind:value={pedestrian.medicalHistory}
              />
            </div>
            <div class="col-12 mb-2">
              <Label>Parte Facultativo</Label>
              <Input
                type="textarea"
                rows={6}
                bind:value={pedestrian.optionalPart}
              />
            </div>
          </div>
        </TabPane>
      {/if}

    </TabContent>

  </ModalBody>
  <ModalFooter>
    <button class="btn btn-success" type="button" on:click={savePedestrianTraffic}>Guardar</button>
  </ModalFooter>
</Modal>

